import { Col, Row, Table } from 'reactstrap';
import { ContentBlock } from '../../Shared/Content/ContentBlock';
import { ContentHeading } from '../../Shared/Content/ContentHeading';
import { ContentBody } from '../../Shared/Content/ContentBody';

export const Basics = () => {
    return (
        <div id="basics">
            <ContentBlock className="evSupplyEquipmentSection">
                <ContentHeading title="Electric Vehicle Supply Equipment Basics" />
                <ContentBody>
                    <div className="heading5">
                        All EVs require some electric vehicle supply equipment (EVSE), such as charging stations, especially in fleet applications. These charging stations come in all kinds of different shapes and sizes that fit in with a variety of vehicle platforms.
                    </div>
                    <Row className="contentBlock tableBlock">
                        <Col>
                            <Table responsive striped className="evseBasicsChargingLevels">
                                <caption>EVSE Basics: Charging Levels</caption>
                                <thead>
                                    <tr>
                                        <th>Type</th>
                                        <th>Charging Time<sup className={'super-footnote'}>1</sup></th>
                                        <th>Range<sup className={'super-footnote'}>1</sup></th>
                                        <th>Charging Load (kW)</th>
                                        <th>Voltage Input (V)</th>
                                        <th>Amps</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><strong>Level 1</strong></td>
                                        <td>Fewer than 10 hours for a full charge</td>
                                        <td>2–5 miles of range added per hour</td>
                                        <td>1.4–1.9 kW</td>
                                        <td>Use a standard 120 V AC plug, one-phase service with a three-prong electrical outlet</td>
                                        <td>12-20 amps</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Level 2</strong></td>
                                        <td>4-6 hours for a full charge</td>
                                        <td>10–20 miles of range added per hour</td>
                                        <td>2-19.2 kW</td>
                                        <td>Use a 208 V (commercial) or 240 V (residential) AC split phase service</td>
                                        <td>Fewer than 80 amps (typically 30)</td>
                                    </tr>
                                    <tr>
                                        <td><strong>DC Fast Charger</strong></td>
                                        <td>About 30 minutes for a full charge</td>
                                        <td>60–80 miles of range added per 20 minutes of charging</td>
                                        <td>50 kW+</td>
                                        <td>Use 208 V or 480 V AC, three-phase service connection requiring a dedicated circuit</td>
                                        <td>Fewer than 200 amps (typically 60)</td>
                                    </tr>
                                </tbody>
                            </Table>

                            <div className="disclaimer">
                                <sup className={'super-footnote'}>1</sup>Exact charging range and times depend on the charger load specifications, circuit amperage, vehicle type, and size of the electric battery.
                            </div>

                            <div className="subContent">
                                <h4 className="css_heading bold">EVSE Basics: Port Connector Types</h4>
                                <div className="body indent">
                                    <p>
                                        <h5 className="css_heading bold">Level 1 and 2 Chargers:</h5>
                                        J1772: All EVs, including Tesla vehicles with an adapter, can use the J1772 connector.
                                    </p>

                                    <p>
                                        <h5 className="css_heading bold">DC Fast Charger:</h5>
                                        <ul>
                                            <li>CCS (or J1772 Combo): Used by BMW, Daimler, Ford, Jaguar, General Motors, and Volkswagen models, and certain Honda, Hyundai, Kia, Nissan, and Mazda models.</li>
                                            <li>CHAdeMO: Used by certain Honda, Hyundai, Kia, Mazda, Mitsubishi, Nissan, Subaru, and Toyota models.</li>
                                            <li>Tesla: Only used by Tesla models.</li>
                                        </ul>
                                    </p>

                                </div>

                                <h4 className="css_heading bold">EVSE Basics: Models</h4>
                                <div className="body indent">
                                    <p>
                                        There are over 50 EV charger vendors with hundreds of available models of Level 2 (stand-alone or wall-mounted) and DC fast charger charging stations to choose from.
                                    </p>
                                </div>

                                <h4 className="css_heading bold">EVSE Basics: Connectivity</h4>
                                <div className="body indent">
                                    <p>
                                        <h5 className="css_heading bold">Non-Networked Chargers:</h5>
                                        <ul>
                                            <li>Stand-alone Level 1 or 2 chargers, with no hardware or software for remote management</li>
                                            <li>Least expensive option</li>
                                            <li>Best suited for residential and small workplace settings</li>
                                        </ul>
                                    </p>
                                </div>
                                <div className="body indent">
                                    <p>
                                        <h5 className="css_heading bold">Networked Chargers:</h5>
                                        <ul>
                                            <li>Connected with a network service provider's software for remote management (e.g., mobile apps)</li>
                                            <li>Mobile apps can help fleet managers and drivers to stay connected and monitor the vehicles</li>
                                            <li>Allow for monitoring of maintenance needs, up-time, and energy use</li>
                                            <li>Enable participation in demand response utility programs</li>
                                            <li>Require network fees ($100–$900 annually, depending on the model)</li>
                                            <li>Can be closed (proprietary communication protocol) or open (standard communication protocol, allowing for changes in network); see more info at the Open Charge Alliance</li>
                                        </ul>
                                    </p>
                                </div>
                            </div>

                            <div className="referenceContent">
                                <p>Learn more at <a href="https://fueleconomy.gov" target="_blank" rel="noreferrer">FuelEconomy.gov</a> and the <a href="https://afdc.energy.gov/" target="_blank" rel="noreferrer">Alternative Fuels Data Center</a>.</p>
                            </div>
                        </Col>
                    </Row>

                </ContentBody>
            </ContentBlock>
        </div>
    );

};
